import * as React from "react";
import ProjectDetails from "./ProjectDetails";
const galleryImages = [{
  id: 1,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-1-scaled.jpg?v=s2ouzd9ahbn",
  alt: "Pareklisia residence exterior view"
}, {
  id: 2,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-8-1.jpg?v=g9chmhk50q",
  alt: "Interior living room renovation"
}, {
  id: 3,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-10.jpg?v=zgrk07omhx",
  alt: "Modern kitchen remodel"
}, {
  id: 4,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-9.jpg?v=r4g67dyp2c",
  alt: "Master bedroom interior design"
}, {
  id: 5,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-11.jpg?v=zk1o4eg238",
  alt: "Luxury bathroom renovation"
}, {
  id: 6,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-4-scaled.jpg?v=v611037c2wf",
  alt: "Outdoor terrace and garden"
}, {
  id: 7,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-15.jpg?v=m6v0ym3akla",
  alt: "Outdoor terrace and garden"
}, {
  id: 8,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-17.jpg?v=dm9ihq7o1re",
  alt: "Outdoor terrace and garden"
}, {
  id: 9,
  src: "https://theksway.com/wp-content/uploads/2026/04/PXL_20260402_141120928.jpg?v=vnjd31un0g",
  alt: "Outdoor terrace and garden"
}, {
  id: 10,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-19.jpg?v=1iaaopubkqt",
  alt: "Outdoor terrace and garden"
}, {
  id: 11,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-3-scaled.jpg?v=7a6n24p1rpe",
  alt: "Outdoor terrace and garden"
}, {
  id: 12,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-2-scaled.jpg?v=0itur1gb2aqf",
  alt: "Outdoor terrace and garden"
}, {
  id: 13,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-7-scaled.jpg?v=ro5y2lpqhwe",
  alt: "Outdoor terrace and garden"
}, {
  id: 14,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-6-scaled.jpg?v=kxifvp4ihg",
  alt: "Outdoor terrace and garden"
}, {
  id: 15,
  src: "https://theksway.com/wp-content/uploads/2026/04/Palodia-Residence-Renovation-5-scaled.jpg?v=chlhaq5lh0e",
  alt: "Outdoor terrace and garden"
}];
export default function ProjectHeroImage() {
  return <section id="project-hero-image" className="bg-[#fff] py-12">
      <div className="w-full px-8 max-w-[1920px] mx-auto">
        <h1 className="text-center font-bold mb-10 !text-[27px]">Palodia Residence Renovation</h1>
        <ProjectDetails />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className="overflow-hidden rounded-[0.5rem] bg-muted/20">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover aspect-[4/3] transition-transform duration-500 hover:scale-105" loading={i < 3 ? "eager" : "lazy"} />
            </div>)}
        </div>
      </div>
    </section>;
}